<template>
  <ValidationObserver ref="form" v-slot="{ handleSubmit, errors }">
    <article class="filter-container mt-2">
      <div class="row">
        <div class="col-12 col-md-4">
          <ValidationProvider
            name="searchInput"
            rules="required"
            mode="passive"
          >
            <CustomInput
              v-model="searchField"
              data-vv-validate-on="change"
              placeholder="Escriba nombre del estudiante o número de SIE"
              icon="fa fa-search orange-icon"
              left-icon
            />
          </ValidationProvider>
        </div>
        <div
          :class="[
            'col-12 mt-2 mt-md-0',
            { 'col-md-4': showSyncButton, 'col-md-5': !showSyncButton },
          ]"
        >
          <ActionButton
            type="submit"
            text="Buscar"
            variant="success"
            i="fas fa-search"
            class="mr-2"
            :responsive="isMobile"
            @click="handleSubmit(submitSearch)"
          />
          <ActionButton
            v-if="showCancelButton"
            text="Cancelar"
            variant="danger"
            class="mr-2"
            i="fas fa-times-circle"
            :responsive="isMobile"
            @click="cancel"
          />
          <ActionButton
            v-if="showAddStudentButton"
            text="Añadir Estudiante"
            variant="outline-success"
            i="fas fa-user-plus"
            :responsive="isMobile"
            :class="{ 'mt-2': showCancelButton }"
            @click="$emit('show-add-student', true)"
          />
        </div>
        <div class="col-12 col-md-3 mt-2 text-md-right">
          {{ textCount }}
          <span class="text-orange">
            {{ studentCount }}
          </span>
        </div>
        <div
          v-if="showSyncStudentButton && showSyncButton"
          class="col-12 col-md-1 mt-2 mt-md-0 text-md-right"
        >
          <ActionButton
            variant="outline-success"
            i="fas fa-redo-alt"
            :responsive="isMobile"
            @click="$emit('on-sync')"
          />
        </div>
      </div>
    </article>
    <slot />
    <CustomError
      v-if="errors.searchInput && errors.searchInput.length"
      variant="no-border"
      message="Favor escriba el nombre o número de SIE del estudiante para obtener resultados de la búsqueda."
      class="mt-1"
    />
  </ValidationObserver>
</template>

<script>
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import CustomError from 'custom-error';

export default {
  name: 'StudentsHeaderFilter',
  components: {
    CustomInput,
    ActionButton,
    CustomError,
  },
  props: {
    studentCount: {
      type: Number,
      default: 0,
    },
    showAddStudentButton: {
      type: Boolean,
      default: true,
    },
    showSyncStudentButton: {
      type: Boolean,
      default: false,
    },
    textCount: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      showCancelButton: false,
      searchField: null,
    };
  },
  computed: {
    showSyncButton() {
      return this.showAddStudentButton || this.$slots.default;
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
  methods: {
    submitSearch() {
      this.$emit('on-search', this.searchField);
      this.showCancelButton = true;
    },
    cancel() {
      this.searchField = null;
      this.$emit('on-search', this.searchField);
      this.showCancelButton = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@import '@/assets/scss/variables/_colors.scss';

.filter-container {
  background-color: $gray;
  padding: 15px;
  border-radius: 5px;
}
</style>
